<template>
  <div>
    <base-header class="pb-6" type="blue">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Analytics</h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>-->
        </div>
      </div>
      <!-- Card stats -->
      <div v-show="kpis.length == 0" style="height:127px;">
        <div class="col text-center">
          <i class="fas fa-6x fa-capsules fa-pulse"></i>
        </div>
      </div>
      <div class="row" v-show="kpis.length > 0">
        <div class="col-xl-4 col-md-12" v-for="kpi in kpis"
            :key="kpi.PrimaryLabel"
        >
          <stats-card
            :title="kpi.primaryLabel"
            type="gradient-green"
            :sub-title="kpi.primaryValue"
            :icon="kpi.icon"
          >
            <template slot="footer">
              <span class="text-success mr-2" v-show="kpi.secondaryValue != null">
                <i class="fa fa-arrow-up"></i> {{kpi.secondaryValue}}
              </span>
              <span class="text-nowrap">{{kpi.secondaryLabel}}</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-8">
        </div>

        <div class="col-xl-4">
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";

// Components
import StatsCard from "@/components/Cards/StatsCard";

// Lists

// Tables

export default {
  components: {
  },
  data() {
    return {
      kpis: []
    };
  },
  methods: {
    loadData(){
      this.axios.get("KPI")
        .then(data => this.kpis.push(...data.data));
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style></style>
